"use client";
import { DestinationsGalleryProps } from "@/app/components/DestinationsGallery";
import { GalleryDesktop } from "@/app/components/GalleryDesktop";
import { GallerySliderMobile } from "@/app/components/GallerySliderMobile";
import React from "react";
import { useMediaQuery } from "@/app/hooks/useMediaQuery";

export const GalleryWrapper = ({ data }: DestinationsGalleryProps) => {
  const isMobile = useMediaQuery("(max-width:1024px)");

  if (isMobile === null) {
    return (
      <div className="min-h-[480px] w-full" aria-hidden="true" />
    );
  }

  return (
    <>
      {isMobile ? (
        <GallerySliderMobile data={data} />
      ) : (
        <GalleryDesktop data={data} />
      )}
    </>
  );
};
